// extracted by css-extract-rspack-plugin
export default {"none":"css-none-905476"};